import styled from '@emotion/styled';
import { ArrowRight } from '@icons/index';
import { Close } from '@mui/icons-material';
import { Button, CircularProgress, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { auditsFollowUpService } from '@store/audits/audit-offer-followUp/audit-offer-followUp.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import { OfferFollowUpDetailsRoutes } from '@utils/routes.utils';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { finalize } from 'rxjs';
import DetailsModal from './Details.modal';

const BoxOffer = styled(Stack)({
  border: '1px solid #E4E6E9',
  borderRadius: '4px',
  padding: '18px 20px',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  marginTop: '26px'
});

const OfferDetails = () => {
  const navigate = useNavigate();
  const { offerId } = useParams();
  const [{ auditsProposalDetails }] = useObservable(auditOfferFollowUpQuery.auditProposalDetails$);
  const createdAt = auditsProposalDetails?.createdAt ? dayjs(auditsProposalDetails.createdAt) : null;
  const expireAt = auditsProposalDetails?.expireAt ? dayjs(auditsProposalDetails.expireAt) : null;
  const [loading, setLoading] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  useEffect(() => {
    if (offerId) {
      setLoading(true);
      auditsFollowUpService.getAuditsProposalDetails(offerId)
        .pipe(finalize(() => setLoading(false)))
        .subscribe();
    }
  }, [offerId]);

  const handleClose = () => {
    navigate(-1);
  };

  const handleOpenDetailModal = (offerStatusId: number) => {
    navigate(`../${OfferFollowUpDetailsRoutes.DETAILS_OFFERSTATUS}/${offerStatusId}`);
  };

  return (
    <Drawer PaperProps={{ sx: { paddingInline: 0 } }} anchor="right" open onClose={handleClose}>
      {loading ? (
        <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
          <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
        </Stack>
      ) : (
        <>
          <Stack px='20px' mb={'40px'}>
            <Stack direction="row" justifyContent="flex-end">
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Stack>
            <Stack>
              <Typography fontSize={18} fontWeight={700} mb={'25px'}>
                {auditsProposalDetails?.name ?? '-'}
              </Typography>
              <Stack spacing={1}>
                {[{ title: 'Site', value: auditsProposalDetails?.name },
                { title: 'Rédigé le', value: createdAt?.format('DD/MM/YYYY') || '-' },
                { title: 'Date limite', value: expireAt?.format('DD/MM/YYYY') || '-' }].map((item, idx) => (
                  <Stack key={`${item}-${idx}`} direction="row" alignItems="center">
                    <Stack maxWidth={'100px'} flex={1}>
                      <Typography fontSize="14px" fontWeight={400} color="#8D95A2">
                        {item.title}
                      </Typography>
                    </Stack>
                    <Typography fontSize="14px" fontWeight={400} color="#192133">
                      {item.value}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
              <BoxOffer direction='row'>
                <Typography fontSize='14px' fontWeight={400} color='#192133'>
                  Offre Metawaste
                </Typography>
                <Button variant='contained' color='primary' sx={{ maxWidth: '150px', height: '30px' }} onClick={() => setOpenDetails(true)}>
                  <Typography fontSize='14px' fontWeight={400} color='#192133' noWrap>
                    Consulter l’offre
                  </Typography>
                </Button>
              </BoxOffer>
            </Stack>
          </Stack>
          <Stack spacing={2} bgcolor='#F4F6F8' p="20px 10px 20px 20px" height={'100dvh'}>
            <Typography fontSize='14px' fontWeight={700} color='#192133'>
              Partenaires
            </Typography>
            <Stack height={'62dvh'} className="scrollable" py={'10px'} pr="10px" overflow="auto" spacing={2}>
              {auditsProposalDetails?.auditProposalSuppliers.map((it) => (
                <Stack key={it.id} direction="row" alignItems="center" justifyContent="space-between" bgcolor='#FFFFFF' borderRadius='4px' p='30px 20px'>
                  <Typography fontSize='14px' fontWeight={400} color='#192133'>
                    {it.supplierUnit.name}
                  </Typography>
                  <IconButton onClick={() => handleOpenDetailModal(it.id)}>
                    <ArrowRight style={{ height: 17, width: 10 }} />
                  </IconButton>
                </Stack>
              )
              )}
            </Stack>
          </Stack>
        </>
      )}
      {openDetails ? (
        <DetailsModal partnerId={offerId} handleClose={() => setOpenDetails(false)} />
      ) : null}
    </Drawer >
  );
};

export default OfferDetails;